import { steps } from "@/data/site";

export default function CaraBelanja() {
    return (
        <section
            data-testid="cara-belanja-section"
            className="wx-container mt-10"
        >
            <div className="flex items-baseline justify-between">
                <h2 className="text-lg font-semibold text-[color:var(--wx-ink)] tracking-tight">
                    Cara Belanja
                </h2>
                <span className="wx-eyebrow">5 Langkah</span>
            </div>

            <ol className="mt-4 wx-card divide-y divide-[color:var(--wx-line)] overflow-hidden">
                {steps.map((s) => (
                    <li
                        key={s.n}
                        data-testid={`step-${s.n}`}
                        className="flex items-start gap-3 p-4"
                    >
                        <span className="shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-full bg-[color:var(--wx-blueSoft)] text-[color:var(--wx-blue)] text-xs font-bold">
                            {s.n}
                        </span>
                        <div className="min-w-0">
                            <p className="text-sm font-semibold text-[color:var(--wx-ink)] leading-tight">
                                {s.title}
                            </p>
                            <p className="mt-1 text-xs text-[color:var(--wx-muted)] leading-relaxed">
                                {s.desc}
                            </p>
                        </div>
                    </li>
                ))}
            </ol>
        </section>
    );
}
